var map = {
	"./klapp.jpg": 222,
	"./ldr.jpg": 223,
	"./matis.jpg": 224,
	"./ocean.jpg": 225,
	"./vie.jpg": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 699;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands nonrecursive \.jpg$
// module id = 699
// module chunks = 1